import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 薬内容の値オブジェクト
 */
export class DrugContent extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): DrugContent {
    return new DrugContent(value);
  }
}
